var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentItem',{attrs:{"name":_vm.name}},[_c('Dropdown',{style:('width:200px;'),attrs:{"items":_vm.calendar,"selected":_vm.firstday},on:{"change":_vm.selectDay}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }